import './AppNotifications.scss';
import { useLocation } from "react-router-dom";
import { NotificationInterface } from "../../models/app";
import AppNotification from "../AppCommon/AppNotification/AppNotification";
import { NOTIFICATION_TYPE } from "../../constants/common";
import { useEffect, useState } from 'react';
import { useNotifications } from '../../providers/NotificationProvider';

interface Props {
      style?: React.CSSProperties
}

export const AppNotifications = ({
      style = {}
}: Props) => {
      const { notifications } = useNotifications();
      const [activeNotifications, setActiveNotifications] = useState<NotificationInterface[]>([]);
      const location = useLocation();

      useEffect(() => {
            const extractActiveNotifications = () => {
                  const activeNotifications = notifications.filter((notification) => notification.notificationStartTime <= Date.now() && notification.notificationEndTime >= Date.now());
                  setActiveNotifications(activeNotifications);
            };
            
            extractActiveNotifications();
            const interval = setInterval(() => {
                  extractActiveNotifications();
            //}, 1000);
            // Check for active notification windows every minute
            }, 60 * 1000);

            return () => {
                  clearInterval(interval);
            };
            // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [notifications]);

      return (
            <>
                  {activeNotifications.length > 0 &&
                  <div className="app-notifications" style={style}>
                        {activeNotifications.map((notification: NotificationInterface, index) => (
                              <AppNotification 
                                    key={index}
                                    message={
                                    location.pathname.includes('fr') ? 
                                    `${notification.notificationTitleFr ? 
                                    `<strong>${notification.notificationTitleFr}:</strong> ` : ''}${notification.notificationTextFr}` 
                                    : 
                                    `${notification.notificationTitleEn ? 
                                    `<strong>${notification.notificationTitleEn}:</strong> ` : ''}${notification.notificationTextEn}` 
                              } type={NOTIFICATION_TYPE.neutral} />
                        ))}
                  </div>}
            </>
      )
};